// App.js
import React from 'react';
import { ThemeProvider } from 'styled-components';
import _ from 'lodash';
import {
  Flex, Box, Text, Loading,
} from './components';
import theme from './theme';
import ActionList from './ActionList';
import ADPFormActionContent from './ADPFormActionContent';
import PaychexFormActionContent from './paychex/PaychexFormActionContent';
import ADPReview from './ADPReview';
import PaychexReview from './paychex/PaychexReview';
import Axios from './request';
import HamburgerButton from './HamburgerButton';
import CI_FillFormActionContent from './collect-info/FillFormAction';
import CI_ReviewForm from './collect-info/ReviewForm';
import WOTC_FillFormAction from './wotc/FillFormAction';
import WOTC_ViewResult from './wotc/ViewResult';
import SD_SignDocumentAction from './sign-document/SignDocumentAction.js';
import SD_ViewResult from './sign-document/ViewSigningResult.js';
import W4VersionAdapter from './w4/W4VersionAdapter';
import BI_EmployeeFillFormActionContent from './basic-information/EmployeeFillFormAction';
import BI_HrFillFormActionContent from './basic-information/HrFillFormAction';
import EverifyForm from './e-verify/EverifyForm';
import I9_EmployeeFillForm from './i9/EmployeeFillForm';
import I9_EmployerFillForm from './i9/EmployerFillForm';
import DirectDeposit_EmployeeFillForm from './direct-deposit/EmployeeFillFormV2';
import StateTaxVersionAdapter from './state-tax-withholding/StateTaxVersionAdapter';
import EhxWotcModule from './ehx-wotc';
import ConnectorIframe from './external-connectors/ConnectorIframe';
import './App.css';
import { Button } from './styles';

// This is a new version that works for the multiple assignees in an action
// A master assignee is the assignee who currently working on the action. For
// example, in Form I9 module employer form, it takes 4 steps to finish the
// action, so the assignee that who take the 1st step in the first place will
// be marked as the `master assignee`. Other assignees will not be allowed to
// work on this action anymore.
export const isActionMasterAssigneeMatchCompanyStaff = (
  assignees = [],
  companyStaff,
) => {
  const masterAssignee = assignees.find((item) => item.is_master === true);
  if (
    masterAssignee
    && masterAssignee.company_staff
    && masterAssignee.company_staff.id === companyStaff.id
  ) return true;
  return false;
};

export const getMasterAssignee = (assignees) => {
  const masterAssignee = assignees.find((item) => item.is_master === true);
  return masterAssignee;
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      processData: props.processData,
      isSidebarOpen: false,
      selectedActionId: this.initSelectedActionId(props),
      timer: null,
      actionContentloading: false,
      showWelcomeMat: false,
      isDirectURLAccess: true,
    };
    /* Feature Flag to check if it using the new tax service */
    this.isNewTaxService = isNewTaxService === 'true';
    this.isOnboardingV2 = isOnboardingV2 === 'true';
  }

  componentDidMount() {
    parent.window.postMessage('loading complete', '*');

    window.addEventListener('pageshow', this.handlePageShow.bind(this));

    if (this.isOnboardingV2) {
      const isFromHris = getQueryStringParam('from') === 'hris';
      const token = window.onboardingV2Token;
      if (!isFromHris || !token) {
        const employeeRecordUuid = this.state.processData.employee_record_uuid;
        const onboardV2Link = `${ONBOARD_V2_HOST}/onboard/${employeeRecordUuid}`;
        window.open(onboardV2Link, '_self');
      }
    }

    /*
    1. If there is no selectedActionId, it means the user is accessing through the onboarding link
    2. checkWelcomeMat() logic to see if it needs to show the welcome page
    3. Else, fetch the process data based on the selectedActionId
    */
    if (this.isNewTaxService || this.isOnboardingV2) {
      const selectedActionId = getQueryStringParam('currActionId') || this.state.selectedActionId;

      if (!selectedActionId && !selectedModuleId) {
        this.setState({ isDirectURLAccess: false });
        this.checkWelcomeMat();
        return;
      }

      this.fetchProcessData(selectedActionId, (res) => {
        if (this.isOnboardingV2) {
          this.redirectToV2HomeIfCompleted(res.data.employee_onboarding_process, selectedActionId);
        }
        this.setState({
          processData: res.data.employee_onboarding_process,
          isDirectURLAccess: false,
        });
      });
    } else {
      this.checkWelcomeMat();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  handlePageShow(event) {
    if (this.isOnboardingV2 && event.persisted) {
      const selectedActionId = this.initSelectedActionId(this.props);
      this.fetchProcessData(selectedActionId, (res) => {
        this.redirectToV2HomeIfCompleted(res.data.employee_onboarding_process, selectedActionId);
      });
    }
  }

  initSelectedActionId(props) {
    if (!selectedModuleId) {
      return props.processData.current_display_action_id;
    }

    const selectedModule = _.find(processData.employee_onboarding_modules, {
      id: Number(selectedModuleId),
    });
    const sortedActions = selectedModule.actions.sort(
      (a, b) => a.sequence - b.sequence,
    );
    const preferredAction = sortedActions.find(
      (action) => action.id === Number(onboardingActionId),
    );
    const selectedAction = preferredAction
      || _.find(sortedActions, (a) => a.status !== 'completed')
      || sortedActions[sortedActions.length - 1];

    return selectedAction.id;
  }

  refreshProgressData() {
    const success = (responseData) => {
      const { employee_onboarding_process: processData } = responseData.data;
      this.setState({ processData });
    };
    const failed = () => {
      alert('Cannot load this step...');
    };
    const { selectedActionId } = this.state;
    this.fetchProcessData(selectedActionId, success, failed);
  }

  checkActionStatus() {
    const { selectedActionId, processData } = this.state;
    const actions = this.getAllActions(processData);
    const selectedAction = _.find(actions, { id: selectedActionId });
    const { wotc_employee: { digest_key: digestKey } } = selectedAction;

    this.fetchWotcEmployeeStatus(digestKey, (res) => {
      const { wotc_employee: { submitted_at: submitted } } = res.data;

      if (submitted) {
        if (this.isOnboardingV2) {
          this.manuallyToNextModule(selectedAction.module_id);
        } else {
          window.location.reload();
        }
      }
    });
  }

  onSendToADPSuccess() {
    window.location.href = window.location.href;
  }

  onSendToPaychexSuccess(responseData) {
    if (responseData.data.message) alert(responseData.data.message);
    window.location.href = window.location.href;
  }

  manuallyToNextModule(moduleId) {
    const modulesSupportInObV2Link = {
      us_state_tax: 'state-tax',
      w4: 'w4',
    };
    const { processData } = this.state;
    const modules = processData.employee_onboarding_modules;
    const currentModule = modules.find((mod) => mod.id === moduleId);
    const notCompletedActions = currentModule.actions.filter(
      (action) => action.is_employee_action && (action.status !== 'completed' && action.status !== 'locked'),
    );
    if (notCompletedActions.length > 1) {
      window.location.href = window.location.href;
      return;
    }

    const currentModuleIndex = modules.findIndex((mod) => mod.id === moduleId);

    const nextModule = modules
      .slice(currentModuleIndex + 1)
      .find((module) => module.actions.some((action) => action.status !== 'completed' && action.status !== 'locked'));

    if (currentModuleIndex === modules.length - 1 || currentModuleIndex === -1 || !nextModule) {
      const onboardV2Link = `${ONBOARD_V2_HOST}/onboard/${window.onboardingV2Token}`;
      window.open(onboardV2Link, '_self');
    } else {
      if (modulesSupportInObV2Link[nextModule.module_type]) {
        const onboardV2Link = `${ONBOARD_V2_HOST}/onboard/${window.onboardingV2Token}/${modulesSupportInObV2Link[nextModule.module_type]}`;
        window.open(onboardV2Link, '_self');
        return;
      }
      const nextModuleId = nextModule.id;
      const url = new URL(window.location.href);
      url.searchParams.set('selectedModuleId', nextModuleId);
      window.open(url.toString(), '_self');
    }
  }

  renderActionContent(action) {
    // We display different content base on two factors
    // 1. action execute status: not_started | others
    // 2. user role: admin | others (Vincent will provide data later)
    const { companyStaff, companyId } = this.props;
    const {
      processData: {
        prefilled_data: prefilledData,
        digest_key: digestKey,
        locked_data: dataFromEi,
        employee_onboarding_modules,
        i9_form: i9Form,
        uuid: processUUID,
      },
    } = this.state;

    const modules = this.state.processData.employee_onboarding_modules;
    const adp_module = modules.find((module) => { if (module.module_type === 'adp') return module; });
    const paychex_module = modules.find((module) => { if (module.module_type === 'paychex') return module; });
    const i9_module = modules.find((module) => { if (module.module_type === 'i9') return module; });

    let config = null;

    if (adp_module !== undefined) {
      config = adp_module.config;
    }

    if (paychex_module !== undefined) {
      config = paychex_module.config;
    }

    const { action_type: actionType } = action;

    const employee_onboarding_module = employee_onboarding_modules.find(
      (module) => module.module_type === 'direct_deposit',
    );

    let content;
    if (action.status === 'locked') {
      return this.renderLockedContent();
    }
    switch (actionType) {
      case 'hr_fill_i9_form': {
        if (
          action.status === 'not_started'
          || action.status === 'in_progress'
          || action.status === 'redo'
        ) {
          content = (
            <I9_EmployerFillForm
              action={action}
              prefilledData={prefilledData && prefilledData.i9}
              title="Fill employer Form I-9"
              onSignedSuccess={() => {
                window.location.reload();
              }}
              companyStaff={companyStaff}
              refreshProgressDataFn={this.refreshProgressData.bind(this)}
            />
          );
        } else if (
          action.status === 'completed'
          && companyStaff
          && companyStaff.id
        ) {
          content = (
            <I9_EmployerFillForm
              action={action}
              title="Fill employer Form I-9"
              onSignedSuccess={() => {
                window.location.reload();
              }}
              companyStaff={companyStaff}
              viewResultAsManager
            />
          );
        } else if (action.status === 'completed') {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      }
      case 'employee_fill_i9_form': {
        if (action.status === 'not_started' || action.status === 'redo') {
          content = (
            <I9_EmployeeFillForm
              action={action}
              i9Form={i9Form}
              dataFromEi={dataFromEi && dataFromEi.i9}
              prefilledData={prefilledData && prefilledData.i9}
              title="Fill employee Form I-9"
              onSignedSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
              companyStaff={companyStaff}
              config={i9_module.config}
              refreshProgressDataFn={this.refreshProgressData.bind(this)}
            />
          );
        } else if (
          action.status === 'completed'
          && companyStaff
          && companyStaff.id
        ) {
          content = (
            <I9_EmployeeFillForm
              action={action}
              i9Form={i9Form}
              title="Fill employee Form I-9"
              onSignedSuccess={() => {
                window.location.reload();
              }}
              companyStaff={companyStaff}
              viewResultAsManager
            />
          );
        } else if (action.status === 'completed') {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      }
      case 'w4_form': {
        if (action.status === 'not_started' || action.status === 'redo') {
          content = (
            <W4VersionAdapter
              company={this.props.company}
              processData={this.state.processData}
              action={action}
              prefilledData={prefilledData && prefilledData.w4}
              dataFromEi={dataFromEi && dataFromEi.w4}
              title="Fill Form W-4"
              onSignedSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
              companyStaff={companyStaff}
            />
          );
        } else if (
          action.status === 'completed'
          && companyStaff
          && companyStaff.id
        ) {
          content = (
            <W4VersionAdapter
              company={this.props.company}
              processData={this.state.processData}
              action={action}
              title="Fill Form W-4"
              onSignedSuccess={() => {
                window.location.reload();
              }}
              companyStaff={companyStaff}
              viewResultAsManager
            />
          );
        } else if (action.status === 'completed') {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      }

      case 'review_and_send_to_adp':
        if (action.status === 'not_started') {
          content = (
            <ADPReview
              action={action}
              title="Review and send to ADP"
              onSendToADPSuccess={() => {
                window.location.reload();
              }}
              companyStaff={companyStaff}
              companyId={companyId}
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'hr_fill_adp_form':
        if (action.status === 'not_started') {
          content = (
            <ADPFormActionContent
              key={action.id}
              action={action}
              prefilledData={prefilledData && prefilledData.adp}
              dataFromEi={dataFromEi && dataFromEi.adp}
              title="Fill ADP form"
              onSubmitADPFormSuccess={() => {
                window.location.reload();
              }}
              companyStaff={companyStaff}
              refreshProgressDataFn={this.refreshProgressData.bind(this)}
            />
          );
        } else if (companyStaff && companyStaff.manage_onboarding) {
          content = (
            <ADPFormActionContent
              key={action.id}
              action={action}
              title="Fill ADP form"
              companyStaff={companyStaff}
              viewResultAsManager
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'employee_fill_adp_form':
        // content = <ADPReview action={action} title="Review and Send to ADP" />
        if (action.status === 'not_started') {
          content = (
            <ADPFormActionContent
              key={action.id}
              action={action}
              config={config}
              prefilledData={prefilledData && prefilledData.adp}
              dataFromEi={dataFromEi && dataFromEi.adp}
              title="Fill ADP form"
              onSubmitADPFormSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
              companyStaff={companyStaff}
            />
          );
        } else if (companyStaff && companyStaff.manage_onboarding) {
          content = (
            <ADPFormActionContent
              key={action.id}
              action={action}
              config={config}
              title="Fill ADP form"
              companyStaff={companyStaff}
              viewResultAsManager
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'sign_document':
        const { status: actionStatus } = action;
        if (actionStatus === 'not_started' || actionStatus === 'redo') {
          // In this UI, better to have a mask on the iframe that make sure companyStaff
          // cannot operate on the iframe
          content = (
            <SD_SignDocumentAction
              key={action.id}
              action={action}
              title="Sign document"
              signLink={
                action.offer.unsigned_offer
                  ? action.offer.unsigned_offer.url
                  : ''
              }
              message={
                action.offer.unsigned_offer
                  ? action.offer.unsigned_offer.message
                  : ''
              }
              onSignedSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
              companyStaff={companyStaff}
              refreshProgressDataFn={this.refreshProgressData.bind(this)}
            />
          );
        } else if (companyStaff && companyStaff.manage_onboarding) {
          content = (
            <SD_ViewResult
              key={action.id}
              title="Sign Document"
              action={action}
            />
          );
        } else {
          // Display success screen to none manager
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'hr_sign_company_document':
      case 'employee_sign_company_document':
        if (
          action.status === 'not_started'
          || action.status === 'in_progress'
          || action.status === 'redo'
        ) {
          // In this UI, better to have a mask on the iframe that make sure companyStaff
          // cannot operate on the iframe
          content = (
            <SD_SignDocumentAction
              key={action.id}
              action={action}
              title={action.name || 'Sign document'}
              signLink={action.unsigned_offer ? action.unsigned_offer.url : ''}
              message={
                action.unsigned_offer ? action.unsigned_offer.message : ''
              }
              onSignedSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
              companyStaff={companyStaff}
              refreshProgressDataFn={this.refreshProgressData.bind(this)}
            />
          );
        } else if (action.status === 'preparing') {
          content = (
            <p>
              This document is being prepared, please try again in a few
              minutes.
            </p>
          );
        } else if (companyStaff && companyStaff.manage_onboarding) {
          content = (
            <SD_ViewResult
              key={action.id}
              title="Sign Document"
              action={action}
            />
          );
        } else {
          // Display success screen to none manager
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'employee_fill_form':
        // when been as re-submit by reviewer, action status will become 'in_progress'
        // so here we need display the form for these two status
        if (
          action.status === 'not_started'
          || action.status === 'in_progress'
          || action.status === 'redo'
        ) {
          content = (
            <CI_FillFormActionContent
              key={action.id}
              action={action}
              title={action.name}
              onSubmitFormSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.href = window.location.href;
                }
              }}
              companyStaff={companyStaff}
            />
          );
        } else {
          // Form completed
          if (companyStaff && companyStaff.manage_onboarding) {
            // Display the actually form submission result to manager
            content = (
              <CI_FillFormActionContent
                key={action.id}
                action={action}
                title="Enter information"
                onSubmitFormSuccess={() => {
                  window.location.href = window.location.href;
                }}
                companyStaff={companyStaff}
                viewResultAsManager
              />
            );
          } else {
            // Display success screen to none manager
            content = this.renderDoneContent({
              text: 'This step has been completed.',
            });
          }
        }
        break;
      case 'review_form':
        if (action.status === 'not_started' || action.status === 'redo') {
          content = (
            <CI_ReviewForm
              key={action.id}
              title="Review form"
              action={action}
              onApproveSuccess={() => {
                window.location.href = window.location.href;
              }}
              onAskResubmitSuccess={() => { }}
              refreshProgressDataFn={this.refreshProgressData.bind(this)}
            />
          );
        } else {
          // Review completed
          if (companyStaff && companyStaff.manage_onboarding) {
            // Display the actual form submission result to manager
            content = (
              <CI_ReviewForm
                key={action.id}
                title="Review form"
                action={action}
                onApproveSuccess={() => { }}
                onAskResubmitSuccess={() => { }}
                viewResultAsManager
              />
            );
          } else {
            // Display success screen to none manager
            content = this.renderDoneContent({
              text: 'This step has been completed.',
            });
          }
        }
        break;
      case 'employee_fill_wotc_form':
        if (
          action.status === 'not_started'
          || action.status === 'in_progress'
          || action.status === 'redo'
        ) {
          content = (
            <WOTC_FillFormAction
              key={action.id}
              title="Fill WOTC form"
              action={action}
              companyStaff={companyStaff}
              checkActionStatus={() => {
                this.checkActionStatus();
              }}
            />
          );
        } else if (companyStaff && companyStaff.manage_onboarding) {
          content = (
            <WOTC_ViewResult
              key={action.id}
              title="Fill WOTC form"
              action={action}
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'employee_fill_basic_information_form':
        // when requested to re-submit by reviewer, action status will become 'in_progress'
        // so here we need to display the form for these two status
        if (
          action.status === 'not_started'
          || action.status === 'in_progress'
          || action.status === 'redo'
        ) {
          content = (
            <BI_EmployeeFillFormActionContent
              key={action.id}
              action={action}
              prefilledData={prefilledData && prefilledData.basic_information}
              title={
                action.status === 'not_started'
                  ? 'Enter basic information'
                  : 'Re-enter basic information'
              }
              onSubmitFormSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
              companyStaff={companyStaff}
            />
          );
        } else {
          // Form completed
          if (companyStaff && companyStaff.manage_onboarding) {
            // Display the actual form submission result to manager
            content = (
              <BI_EmployeeFillFormActionContent
                key={action.id}
                action={action}
                title="Enter basic information"
                onSubmitFormSuccess={() => {
                  window.location.href = window.location.href;
                }}
                companyStaff={companyStaff}
                viewResultAsManager
              />
            );
          } else {
            // Display success screen to non-manager
            content = this.renderDoneContent({
              text: 'This step has been completed.',
            });
          }
        }
        break;
      case 'hr_fill_basic_information_form':
        // when requested to re-submit by reviewer, action status will become 'in_progress'
        // so here we need to display the form for these two status
        if (
          action.status === 'not_started'
          || action.status === 'in_progress'
          || action.status === 'redo'
        ) {
          content = (
            <BI_HrFillFormActionContent
              key={action.id}
              action={action}
              prefilledData={prefilledData && prefilledData.basic_information}
              authCode={authCode}
              title={
                action.status === 'not_started'
                  ? 'Enter employee information'
                  : 'Re-enter employee information'
              }
              onSubmitFormSuccess={() => {
                window.location.href = window.location.href;
              }}
              companyStaff={companyStaff}
            />
          );
        } else {
          // Form completed
          if (companyStaff && companyStaff.manage_onboarding) {
            // Display the actual form submission result to manager
            content = (
              <BI_HrFillFormActionContent
                key={action.id}
                action={action}
                title="Enter employee information"
                onSubmitFormSuccess={() => {
                  window.location.href = window.location.href;
                }}
                companyStaff={companyStaff}
                viewResultAsManager
              />
            );
          } else {
            // Display success screen to non-manager
            content = this.renderDoneContent({
              text: 'This step has been completed.',
            });
          }
        }
        break;
      case 'formi9_section1':
      case 'formi9_section2':
        content = (
          <EverifyForm
            key={action.id}
            action={action}
            authCode={authCode}
            digestKey={digestKey}
            companyStaff={companyStaff}
            onTaskCompleted={() => {
              if (this.isOnboardingV2) {
                this.manuallyToNextModule(action.module_id);
              } else {
                window.location.reload();
              }
            }}
          />
        );
        break;
      case 'direct_deposit_form':
        if (
          action.status === 'not_started'
          || action.status === 'redo'
          || (action.status === 'completed' && companyStaff && companyStaff.id)
        ) {
          content = (
            <DirectDeposit_EmployeeFillForm
              key={action.id}
              action={action}
              authCode={authCode}
              digestKey={digestKey}
              companyStaff={companyStaff}
              companyName={company ? company.name : ''}
              employee_onboarding_module={employee_onboarding_module}
              onSubmitFormSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
            />
          );
        } else {
          // Display success screen to non-manager
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'employee_fill_us_state_tax_form':
        if (
          action.status === 'not_started'
          || action.status === 'in_progress'
          || action.status === 'redo'
        ) {
          content = (
            <StateTaxVersionAdapter
              company={this.props.company}
              processData={this.state.processData}
              action={action}
              companyStaff={companyStaff}
              prefilledData={prefilledData && prefilledData.us_state_tax}
              dataFromEi={dataFromEi && dataFromEi.us_state_tax}
              onSignedSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
            />
          );
        } else {
          // completed
          if (companyStaff && companyStaff.manage_onboarding) {
            content = (
              <StateTaxVersionAdapter
                company={this.props.company}
                processData={this.state.processData}
                action={action}
                companyStaff={companyStaff}
                prefilledData={prefilledData && prefilledData.us_state_tax}
                dataFromEi={dataFromEi && dataFromEi.us_state_tax}
                onSignedSuccess={() => {
                  window.location.reload();
                }}
                viewResultAsManager
              />
            );
          } else {
            content = this.renderDoneContent({
              text: 'This step has been completed.',
            });
          }
        }
        break;
      case 'employee_fill_paychex_form':
      case 'hr_fill_paychex_form':
        if (action.status === 'not_started') {
          content = (
            <PaychexFormActionContent
              key={action.id}
              action={action}
              authCode={authCode}
              prefilledData={prefilledData && prefilledData.paychex}
              dataFromEi={dataFromEi && dataFromEi.paychex}
              companyId={companyId}
              config={config}
              title="Fill Paychex form"
              onSubmitPaychexFormSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
              companyStaff={companyStaff}
            />
          );
        } else if (companyStaff && companyStaff.manage_onboarding) {
          content = (
            <PaychexFormActionContent
              key={action.id}
              action={action}
              authCode={authCode}
              config={config}
              title="Fill Paychex form"
              companyStaff={companyStaff}
              viewResultAsManager
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'review_and_send_to_paychex':
        if (action.status === 'not_started') {
          content = (
            <PaychexReview
              action={action}
              authCode={authCode}
              dataFromEi={dataFromEi && dataFromEi.paychex}
              title="Review and send to ADP"
              companyId={companyId}
              config={config}
              onSendToPaychexSuccess={this.onSendToPaychexSuccess.bind(this)}
              companyStaff={companyStaff}
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'ehx_wotc_employee_form':
        if (action.status !== 'completed') {
          content = (
            <EhxWotcModule
              processUUID={processUUID}
              action={action}
              onEhxWotcSuccessed={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      case 'microservice_action':
        if (
          action.status === 'not_started'
          || (action.status === 'completed' && companyStaff && companyStaff.id)
        ) {
          content = (
            <ConnectorIframe
              key={action.id}
              action={action}
              companyStaff={companyStaff}
              onSubmitFormSuccess={() => {
                if (this.isOnboardingV2) {
                  this.manuallyToNextModule(action.module_id);
                } else {
                  window.location.reload();
                }
              }}
            />
          );
        } else {
          content = this.renderDoneContent({
            text: 'This step has been completed.',
          });
        }
        break;
      default:
        return `Not supported action type ${actionType}.`;
      // TODO: need to report error, an action type is not supported
    }
    return content;
  }

  renderDoneContent({ text }) {
    return (
      <Flex
        flexDirection={['column', 'row']}
        alignItems="center"
        justifyContent="center"
      >
        <img src="/j/images/employee-onboarding/onboarding-done.svg" />
        <Flex flexDirection="column" mt={[50, 0]} ml={[0, 123]}>
          <Text bold fontSize="22px">
            Congratulations
          </Text>
          <Text mt={1}>{text || 'Everything was successfully completed.'}</Text>
        </Flex>
      </Flex>
    );
  }

  renderLockedContent() {
    return (
      <Flex flexDirection={['column', 'row']} alignItems="center" justifyContent="center">
        <img src="/j/images/employee-onboarding/onboarding-done.svg" />
        <Flex flexDirection="column" mt={[50, 0]} ml={[0, 123]}>
          <Text bold fontSize="22px">
            Your employer marked this step as complete
          </Text>
          <Text mt={1}>This step has been completed.</Text>
        </Flex>
      </Flex>
    );
  }

  getAllActions(processData) {
    return processData.employee_onboarding_modules.reduce((acc, module) => {
      let sortedActions = module.actions.sort(
        (a, b) => a.sequence - b.sequence,
      );

      sortedActions = module.actions.map((action) => {
        action.module_type = module.module_type;
        action.module_name = module.name;
        if (action.action_type === 'employee_fill_form') {
          action.name = module.name;
        }
        action.module_id = module.id;
        return action;
      });

      if (module.module_type === 'adp') {
        const adpActions = sortedActions.map((ac) => {
          ac.templateValid = module.template_valid;
          return ac;
        });
        acc = [...acc, ...adpActions];
      } else {
        acc = [...acc, ...sortedActions];
      }
      return acc;
    }, []);
  }

  redirectToV2HomeIfCompleted(processData, selectedActionId) {
    const actions = this.getAllActions(processData);
    const selectedAction = _.find(actions, { id: selectedActionId });
    if (selectedAction.status === 'completed' || selectedAction.status === 'locked') {
      const onboardV2Link = `${ONBOARD_V2_HOST}/onboard/${window.onboardingV2Token}`;
      window.open(onboardV2Link, '_self');
    }
  }

  checkWelcomeMat() {
    const actions = this.getAllActions(this.state.processData);
    const employeeActions = actions.filter(
      (action) => action.is_employee_action,
    );

    const showWelcomeMat = employeeActions.every(
      (action) => action.status === 'not_started' || action.status === 'preparing',
    );

    if (showWelcomeMat) {
      this.setState({ showWelcomeMat: true });
    }
  }

  fetchProcessData(actionId, successCB, failCB) {
    const { processData } = this.state;
    const apiURL = `${APIHOST}/v1/employee_onboarding_processes/${processData.digest_key}`;
    const config = {
      method: 'GET',
      url: apiURL,
      params: {
        ...(actionId && { onboarding_action_id: actionId }),
        // previewMode variable is set in pug file
        ...(previewMode && { preview: true }),
      },
    };
    Axios(config)
      .then((responseData) => {
        if (successCB) successCB(responseData);
      })
      .catch((err) => {
        if (failCB) failCB();
      });
  }

  fetchWotcEmployeeStatus(digestKey, successCB) {
    const apiURL = `${APIHOST}/v1/wotc/employees/${digestKey}/refresh`;
    const config = {
      method: 'POST',
      url: apiURL,
    };
    Axios(config).then((responseData) => {
      if (successCB) successCB(responseData);
    });
  }

  handleSelectAction(actionId) {
    this.trackEmployeeStartAction(actionId, this.state.processData);
    this.setState({ actionContentloading: true });
    this.setState({ isSidebarOpen: false });
    if (this.isNewTaxService) updateQueryStringParam('currActionId', actionId, false);

    const success = (responseData) => {
      const { employee_onboarding_process: processData } = responseData.data;
      this.setState({
        selectedActionId: actionId,
        processData,
        actionContentloading: false,
      });
    };

    const failed = () => {
      this.setState({ actionContentloading: false });
      alert('Cannot load this step.');
    };
    this.fetchProcessData(actionId, success, failed);
  }

  renderActionOwnerNote(action) {
    const { companyStaff } = this.props;
    if (!action) return null;
    if (!companyStaff || !companyStaff.id) return null;
    if (action.status !== 'in_progress') return null;
    if (previewMode) return null;
    const { assignees = [] } = action;
    const masterAssignee = assignees.find((item) => item.is_master === true);
    if (!masterAssignee || !masterAssignee.company_staff) return null;
    if (masterAssignee.company_staff.id === companyStaff.id) return null;
    return (
      <Flex
        mx={-30}
        mt={-55}
        mb={25}
        backgroundColor="#ECF6FD"
        height="36px"
        alignItems="center"
        justifyContent="center"
      >
        <img src="/j/images/onboarding/avatar.svg" />
        <Text color="#0D8CE6" ml="8px">
          {masterAssignee.company_staff.name}
          {' '}
          is already working on this step
        </Text>
      </Flex>
    );
  }

  trackEmployeeStartAction(actionId, processData = {}) {
    const { companyId, companyStaff } = this.props;
    const actions = this.getAllActions(processData);
    const startedAction = actions.find((action) => action.id === actionId) || {};
    const targetModule = processData.employee_onboarding_modules.find((module) => {
      const hasAction = module.actions.find((action) => action.id === actionId);
      return hasAction;
    }) || {};

    window.analytics.track('onboarding - employee started task', {
      action_name: startedAction.name,
      employee_onboarding_action_id: actionId,
      module_name: targetModule.name,
      employee_onboarding_module_id: targetModule.id,
      employee_onboarding_process_id: processData.id,
      employee_id: processData.employee_id,
      company_id: companyId,
      company_staff_id: companyStaff.id,
    });
  }

  render() {
    const { isDirectURLAccess, processData } = this.state;

    /*
      1. Do not mount anything first if isDirectURLAccess
      2. Wait upon processData to be fetched first instead of using props
     */
    if ((this.isNewTaxService || this.isOnboardingV2) && isDirectURLAccess) {
      return (
        <Flex>
          <Loading className="spinner spinner-blue" />
        </Flex>
      );
    }
    const currActionId = Number(getQueryStringParam('currActionId'));
    let { selectedActionId } = this.state;

    if (this.isNewTaxService) {
      if (currActionId) {
        selectedActionId = currActionId;
      }
    }

    let selectedAction;
    const actions = this.getAllActions(processData);
    selectedAction = _.find(actions, { id: selectedActionId });
    // use lodash to find first object with assignee_type === "employee"
    const employeeAssignee = selectedAction
      ? _.find(selectedAction.assignees, {
        assignee_type: 'Employee',
      })
      : null;

    const employeeFirstName = employeeAssignee
      ? employeeAssignee.name.split(/\s+/)[0]
      : '';

    const actionListComponent = (
      <ActionList
        actions={actions}
        selectedActionId={selectedActionId}
        onSelect={this.handleSelectAction.bind(this)}
      />
    );

    return (
      <ThemeProvider theme={theme}>
        <Flex style={{ maxWidth: this.isOnboardingV2 ? 900 : 1536, margin: 'auto' }} flexDirection="column">
          {this.state.showWelcomeMat ? (
            <Flex flexDirection="column" alignItems="center">
              <Flex
                flexDirection="column"
                style={{ width: '354px', gap: '20px' }}
                alignItems="center"
                justifyContent="center"
              >
                <img
                  src="/j/images/welcome-mat.svg"
                  width="166px"
                  height="163px"
                  style={{ marginBottom: '20px' }}
                />
                <Text fontSize="24px" fontWeight="bold">
                  {`${`Congrats ${employeeFirstName}`.trim()}!`}
                </Text>
                <Text
                  fontWeight={400}
                  fontSize="14px"
                  style={{ width: '300px' }}
                >
                  Before starting your new job, you’ll need to complete new hire
                  paperwork. Don’t worry, we’ll walk you through it.
                </Text>
                <Button
                  style={{ width: '300px', marginTop: '80px' }}
                  data-testid="welcome-get-started-btn"
                  onClick={() => {
                    this.setState({ showWelcomeMat: false });
                    const startedAction = actions[0];
                    this.trackEmployeeStartAction(startedAction.id, processData);

                    if (this.isNewTaxService) {
                      const currActionId = this.initSelectedActionId(this.props);
                      updateQueryStringParam('currActionId', currActionId, false);
                    }
                  }}
                >
                  Get started
                </Button>
                <Flex>
                  <img src="/j/images/lock.svg" width="16px" height="20px" />
                  <Text fontSize="12px" fontWeight={400} ml="10px">
                    Encrypted and stored using a secure TLS connection
                  </Text>
                </Flex>
                <Text
                  fontWeight={400}
                  fontSize="12px"
                  textAlign="center"
                  lineHeight="17px"
                >
                  By clicking Get started, you're agreeing to our
                  {' '}
                  <a
                    href="https://www.workstream.us/termsofuse"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms & Conditions
                  </a>
                  {' '}
                  and
                  {' '}
                  <a
                    href="https://www.workstream.us/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                  .
                </Text>
              </Flex>
            </Flex>
          ) : (
            <Flex>
              {/* sidebar */}
              {
                !this.isOnboardingV2 && (
                <Flex
                  maxWidth={[null, 275]}
                  style={{ position: 'sticky', top: 0 }}
                  className="jobs-sidebar"
                  mr={10}
                  bg="white"
                  borderRadius={5}
                  flexDirection="column"
                  flex="1 0 275px"
                >
                  {actionListComponent}
                </Flex>
                )
              }
              {/* action content */}
              <Flex
                flexDirection="column"
                flexGrow={1}
                bg="white"
                borderRadius={5}
                p={20}
                pt={this.isOnboardingV2 ? 0 : [72, 55]}
                position="relative"
              >
                {this.renderActionOwnerNote(selectedAction)}
                <div id="js-note-container" />
                {
                  !this.isOnboardingV2 && (
                    <Flex
                      justifyContent="flex-start"
                      display={['flex', 'none']}
                      // position="absolute"
                      top={32}
                      left={30}
                      className="module-button"
                    >
                      <HamburgerButton
                        isActive={this.state.isSidebarOpen}
                        onClick={() => {
                          this.setState({
                            isSidebarOpen: !this.state.isSidebarOpen,
                          });
                        }}
                      />
                    </Flex>
                  )
                }

                {this.state.isSidebarOpen && (
                  <Box ml="-20px" mr="-20px">
                    {actionListComponent}
                  </Box>
                )}
                <div
                  style={{
                    visibility: this.state.isSidebarOpen ? 'hidden' : 'visible',
                  }}
                >
                  {this.state.actionContentloading ? (
                    <Flex>
                      <Loading className="spinner spinner-blue" />
                    </Flex>
                  ) : (
                    selectedAction && this.renderActionContent(selectedAction)
                  )}
                  {!selectedAction && this.renderDoneContent({})}
                </div>
              </Flex>
            </Flex>
          )}
        </Flex>
      </ThemeProvider>
    );
  }
}

export default App;
